import type { DropdownMenuPlacement } from 'components/Dropdown/types/DropdownMenuPlacement';
import { useSearchRefinementDropdown } from 'modules/search/components/Refinement/Dropdown/useSearchRefinementDropdown';
import type { SearchRefinementType } from 'modules/search/constants/refinements/searchRefinementTypes';
import { useSearchDateRangeSelectedValues } from 'modules/search/hooks/dateRange/useSearchDateRangeSelectedValues';

export function useSearchDateRangeDropdown(
  facetType: SearchRefinementType,
  initialPlacement: DropdownMenuPlacement,
) {
  const selectedDateRangeValues = useSearchDateRangeSelectedValues(facetType);

  const hasSelectedDateRangeValues = Boolean(
    selectedDateRangeValues.endsGT || selectedDateRangeValues.startsLT,
  );

  const { holderRef, placement, toggleDropdown, dropdownStatus } =
    useSearchRefinementDropdown(
      facetType,
      hasSelectedDateRangeValues,
      initialPlacement,
    );

  return { holderRef, dropdownStatus, toggleDropdown, placement };
}
